"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTaskList = void 0;
const react_i18next_1 = require("react-i18next");
const luxon_1 = require("luxon");
const types_1 = require("../../../types");
function useTaskList({ taskListGroups, currentPayPeriod }) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const isEmpty = () => {
        return !taskListGroups.reduce((totalCount, group) => totalCount + (group === null || group === void 0 ? void 0 : group.count), 0);
    };
    let title = t('time_and_attendance_TaskList_Tasks');
    if (taskListGroups.length) {
        if (taskListGroups[0].count === 1) {
            title = t('time_and_attendance_TaskList_Tasks_One');
        }
        else {
            title = t('time_and_attendance_TaskList_Tasks_Other', {
                count: taskListGroups[0].count
            });
        }
    }
    const createRequireAttentionRenderUtils = () => {
        const punchTypeTitleMap = {
            [types_1.PunchType.in]: t('time_and_attendance_TaskList_PunchType_PunchIn'),
            [types_1.PunchType.out]: t('time_and_attendance_TaskList_PunchType_PunchOut'),
            [types_1.PunchType.missed]: t('time_and_attendance_TaskList_PunchType_MissedPunch'),
            [types_1.PunchType.pending]: t('time_and_attendance_TaskList_PunchType_Pending')
        };
        const anomalyTypeMap = {
            [types_1.TaskListAnomalyTypes.DuplicatePunch]: t('time_and_attendance_TaskList_PunchStatus_DuplicatePunch'),
            [types_1.TaskListAnomalyTypes.MissingPunch]: t('time_and_attendance_TaskList_PunchStatus_MissingPunch'),
            [types_1.TaskListAnomalyTypes.SystemAddedPunch]: t('time_and_attendance_TaskList_PunchStatus_SystemAddedPunch')
        };
        const formatSubtitle = (dateTimeString, emptyTime) => {
            const dateTime = luxon_1.DateTime.fromISO(dateTimeString);
            return `${emptyTime ? '--:--' : dateTime.toLocaleString(luxon_1.DateTime.TIME_SIMPLE)} | ${dateTime.toLocaleString(luxon_1.DateTime.DATE_MED)}`;
        };
        const formatTaskItemAriaLabel = (punchStatus, punchType, dateTimeString, dateTimeRenderFormat) => {
            const dateTime = luxon_1.DateTime.fromISO(dateTimeString);
            return `${punchStatus}, ${punchTypeTitleMap[punchType]}, ${dateTime.toLocaleString(dateTimeRenderFormat)}`;
        };
        return {
            punchTypeTitleMap,
            anomalyTypeMap,
            formatSubtitle,
            formatTaskItemAriaLabel
        };
    };
    const addressBeforeMessage = !!(currentPayPeriod === null || currentPayPeriod === void 0 ? void 0 : currentPayPeriod.end_time) &&
        t('time_and_attendance_TaskList_AddressBefore', {
            time: luxon_1.DateTime.fromISO(currentPayPeriod.end_time).toFormat('MMMM dd t')
        });
    const description = t('time_and_attendance_TaskList_DescriptionCopy');
    const descriptionTitle = t('time_and_attendance_TaskList_Tasks');
    const descriptionFull = t('time_and_attendance_TaskList_DescriptionCopy_Full');
    return {
        title,
        addressBeforeMessage,
        description,
        descriptionTitle,
        descriptionFull,
        isEmpty,
        requireAttentionRenderUtils: createRequireAttentionRenderUtils()
    };
}
exports.useTaskList = useTaskList;
